import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ImportConfiguration } from "../../types/importConfiguration";
import { RootState } from "../index";

interface ImportConfigurationState {
  importConfigurations: ImportConfiguration[] | null;
  dataverseImportConfigurations: ImportConfiguration[] | null;
  selectedImportConfiguration: ImportConfiguration | null;
}

const initialState: ImportConfigurationState = {
  importConfigurations: null,
  dataverseImportConfigurations: null,
  selectedImportConfiguration: null
};

export const importConfigurationSlice = createSlice({
  name: "importConfiguration",
  initialState,
  reducers: {
    setSliceImportConfigurations(state, action: PayloadAction<ImportConfiguration[] | null>) {
      state.importConfigurations = action.payload;
    },
    setSliceDataverseImportConfigurations(state, action: PayloadAction<ImportConfiguration[] | null>) {
      state.dataverseImportConfigurations = action.payload;
    },
    setSliceSelectedImportConfiguration(state, action: PayloadAction<ImportConfiguration | null>) {
      state.selectedImportConfiguration = action.payload;
    }
  }
});

export const selectSliceImportConfigurations = (state: RootState) => state.importConfiguration.importConfigurations;
export const selectSliceDataverseImportConfigurations = (state: RootState) =>
  state.importConfiguration.dataverseImportConfigurations;
export const selectSliceSelectedImportConfiguration = (state: RootState) =>
  state.importConfiguration.selectedImportConfiguration;
export const { setSliceImportConfigurations, setSliceDataverseImportConfigurations, setSliceSelectedImportConfiguration } =
  importConfigurationSlice.actions;
